
/* injects from baggage-loader */

'use strict';

import LoginComponent from './login.component';

const LoginPageModule = angular.module('login-module', [
  'ui.router'
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('login', {
        url: '/account/login?ref?alert?email',
        title: 'Login',
        component: 'login',
        hide_nav: true,
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .run(function ($transitions, $location, $rootScope, User) {

    // Handle entrance to login page when user is already logged in
    $transitions.onEnter({ to: 'login' }, transition => {

      if (User.isUserLoggedIn() === true) {
        $location.path('/account/home');
        return transition.router.stateService.target('account.home');
      }

    });

    $transitions.onSuccess({ to: 'login' }, transition => {

      // Hide the header
      $rootScope.appState.hideHeader = true;

      // Hide the footer
      $rootScope.appState.hideFooter = true;

    });

  })
  .component('login', new LoginComponent());

export default LoginPageModule;
